<template>
    <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-card>
            <v-card-title class="py-2">
                <v-icon class="mr-2" color="primary">mdi-cash</v-icon>
                <span class="title">{{ title }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap>
                    <!-- Thông tin khách hàng -->
                    <v-flex lg12 md12 sm12>
                        <v-card class="mb-3" outlined>
                            <v-card-text>
                                <v-layout row wrap class="info-grid">
                                    <v-flex lg3 md3 sm6 class="info-item">
                                        <div class="label">Mã khách</div>
                                        <div class="value">{{ customer.Username || customer.CustomerUsername }}</div>
                                    </v-flex>
                                    <v-flex lg3 md3 sm6 class="info-item">
                                        <div class="label">Tên</div>
                                        <div class="value">{{ customer.FullName || customer.CustomerFullName }}</div>
                                    </v-flex>
                                    <v-flex lg3 md3 sm6 class="info-item">
                                        <div class="label">SĐT</div>
                                        <div class="value">{{ customer.PhoneNumber || customer.CustomerPhone }}</div>
                                    </v-flex>
                                    <v-flex lg3 md3 sm6 class="info-item" v-if="!isHistory">
                                        <div class="label">Tổng tiền hàng</div>
                                        <div class="value">
                                            <v-chip small color="grey lighten-3">{{ totalAmount | currency }}</v-chip>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <!-- Thông tin phí và tổng tiền (cho history) -->
                                <v-layout row wrap v-if="isHistory" class="mt-2">
                                    <v-flex lg3 md3 sm6>
                                        <strong>Phí ship:</strong>
                                        <v-chip small class="ml-1" color="grey lighten-3">{{ customer.ShippingFee | currency }}</v-chip>
                                    </v-flex>
                                    <v-flex lg3 md3 sm6>
                                        <strong>Phí khác:</strong>
                                        <v-chip small class="ml-1" color="grey lighten-3">{{ customer.OtherFee | currency }}</v-chip>
                                    </v-flex>
                                    <v-flex lg3 md3 sm6>
                                        <strong>Tổng thanh toán:</strong>
                                        <v-chip small class="ml-1" color="primary" text-color="white">{{ customer.FinalAmount | currency }}</v-chip>
                                    </v-flex>
                                    <v-flex lg3 md3 sm6>
                                        <strong>Ngày thanh toán:</strong> {{ customer.CreatedDate | display_date }}
                                    </v-flex>
                                </v-layout>

                                <!-- Thông tin phí (cho payment mới) -->
                                <v-layout row wrap v-if="!isHistory" class="mt-2">
                                    <v-flex lg6 md6 sm6 class="field-item pa-1">
                                        <h-currency-input v-model="localShippingFee" label="Phí ship" :decimal="0" @press_enter="updateTotalAmount()" @on_blur="updateTotalAmount()" :disabled="isHistory"></h-currency-input>
                                    </v-flex>
                                    <v-flex lg6 md6 sm6 class="field-item pa-1">
                                        <h-currency-input v-model="localOtherFee" label="Phí khác" :decimal="0" @press_enter="updateTotalAmount()" @on_blur="updateTotalAmount()" :disabled="isHistory"></h-currency-input>
                                    </v-flex>
                                    <!-- <v-flex lg3 md3 sm6 class="info-item">
                                        <div class="label">Tổng thanh toán</div>
                                        <div class="value">
                                            <v-chip small color="primary" text-color="white">{{ finalAmount | currency }}</v-chip>
                                        </div>
                                    </v-flex> -->
                                </v-layout>

                                <!-- Ghi chú và upload ảnh -->
                                <v-layout row wrap v-if="!isHistory" class="mt-0">
                                    <v-flex lg12 md12 sm12 class="field-item">
                                        <div class="label">Ghi chú</div>
                                        <v-textarea v-model="localNote" rows="2" hide-details outlined dense
                                            :disabled="isHistory"></v-textarea>
                                    </v-flex>
                                    <v-flex lg12 md12 sm12 class="field-item">
                                        <div class="label">Bill thanh toán (ảnh hoặc PDF)</div>
                                        <v-file-input v-model="paymentImageFile" outlined dense accept="image/*,.pdf" prepend-icon="mdi-camera" hide-details
                                            :disabled="isHistory" @change="handleImageUpload"></v-file-input>
                                    </v-flex>
                                </v-layout>

                                <!-- Hiển thị bill đã upload (history) -->
                                <v-layout row wrap v-if="isHistory && customer.PaymentImage" class="mt-2">
                                    <v-flex lg12>
                                        <strong>Bill thanh toán:</strong><br>
                                        <v-img :src="customer.PaymentImage" max-width="400" max-height="300" contain class="mt-2"></v-img>
                                    </v-flex>
                                </v-layout>

                                <!-- Hiển thị preview và xóa (khi tạo mới) -->
                                <v-layout row wrap v-if="!isHistory && (paymentImageUrl)" class="mt-2">
                                    <v-flex lg12>
                                        <v-card outlined>
                                            <v-card-title class="subtitle-2">File thanh toán</v-card-title>
                                            <v-card-text>
                                                <div class="d-flex align-center">
                                                    <a :href="paymentImageUrl" target="_blank" class="mr-3">
                                                        <v-img 
                                                          v-if="isImageFile(paymentImageUrl)"
                                                          :src="paymentImageUrl" 
                                                          max-width="200" 
                                                          max-height="150"
                                                          contain
                                                        ></v-img>
                                                        <v-icon v-else large>mdi-file-document</v-icon>
                                                    </a>
                                                    <v-btn 
                                                      small 
                                                      color="error" 
                                                      @click="deletePaymentImage"
                                                      :disabled="uploadingFile"
                                                    >
                                                      <v-icon small>delete</v-icon> Xóa file
                                                    </v-btn>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>

                                <!-- Hiển thị ghi chú (cho history) -->
                                <v-layout row wrap v-if="isHistory && customer.Note" class="mt-2">
                                    <v-flex lg12>
                                        <strong>Ghi chú:</strong> {{ customer.Note }}
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <!-- Danh sách Bill hàng lô -->
                    <v-flex lg12 md12 sm12 v-if="bills.length > 0">
                        <v-subheader class="px-0">Danh sách Bill hàng lô ({{ bills.length }} bill)</v-subheader>
                        <v-data-table 
                            :headers="billHeaders" 
                            :items="bills" 
                            hide-default-footer 
                            disable-pagination 
                            fixed-header 
                            :height="tableHeight"
                            :show-select="!isHistory"
                            v-model="localSelectedBills"
                            item-key="ID"
                            show-expand :expanded.sync="expandedBills"
                            class="elevation-1 mb-4"
                            @item-selected="updateTotalAmount"
                            @toggle-select-all="updateTotalAmount">
                            <template v-slot:item.CreatedDate="{ item }">
                                {{ item.CreatedDate | display_date }}
                            </template>
                            <template v-slot:item.Weight="{ item }">
                                {{ item.Weight | currency('', 1) }}
                            </template>
                            <template v-slot:item.Volume="{ item }">
                                {{ item.Volume | currency('', 2) }}
                            </template>
                            <template v-slot:item.Amount="{ item }">
                                {{ item.Amount | currency }}
                            </template>
                            <template v-slot:item.ShipPrice="{ item }">
                                {{ item.ShipPrice | currency }}
                            </template>
                            <template v-slot:item.TotalAmount="{ item }">
                                <strong>{{ item.TotalAmount | currency }}</strong>
                            </template>
                            
                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length" class="pa-0">
                                    <v-simple-table dense class="product-table">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="grey lighten-4">
                                                    <th>Tên hàng</th>
                                                    <th>Mã hàng</th>
                                                    <th class="text-right">Số kiện</th>
                                                    <th class="text-right">Kg/M³</th>
                                                    <th class="text-center">ĐVT</th>
                                                    <th class="text-right">Đơn giá</th>
                                                    <th class="text-right">Thành tiền</th>
                                                    <th class="text-right">Ship nội địa</th>
                                                    <th class="text-right">Xe lôi</th>
                                                    <th class="text-right">Phí hạ hàng</th>
                                                    <th class="text-right">Phí đóng gỗ</th>
                                                    <th class="text-right">Tổng thanh toán</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="!item.products || item.products.length === 0">
                                                    <td colspan="12" class="text-center grey--text">Không có sản phẩm</td>
                                                </tr>
                                                <tr v-for="(product, idx) in item.products" :key="idx">
                                                    <td>{{ product.ProductName || '-' }}</td>
                                                    <td><a :href="'/hang-lo/quan-ly-ma-boc/'+product.ID" target="_blank">{{ product.ProductCode || '-' }}</a></td>
                                                    <td class="text-right">{{ product.NumberOfPack | currency }}</td>
                                                    <td class="text-right">{{ (product.PriceTypeAuto == 1 ? product.Weight : product.Volume) | currency('', product.PriceTypeAuto == 1 ? 1 : 2) }}</td>
                                                    <td class="text-center">
                                                        <v-chip small :color="product.PriceTypeAuto == 1 ? 'blue' : 'green'" text-color="white">
                                                            {{ product.PriceTypeAuto == 1 ? 'Kg' : 'M3'}}
                                                        </v-chip>
                                                    </td>
                                                    <td class="text-right">{{ (product.PriceTypeAuto == 1 ? product.WeightPrice : product.VolumePrice) | currency }}</td>
                                                    <td class="text-right">{{ product.TotalFeeWeight | currency }}</td>
                                                    <td class="text-right">{{ product.TransactionDeposit | currency }}</td>
                                                    <td class="text-right">{{ product.PedicabDeposit | currency }}</td>
                                                    <td class="text-right">{{ product.LoadDeposit | currency }}</td>
                                                    <td class="text-right">{{ product.ReinforceDeposit | currency }}</td>
                                                    <td class="text-right"><strong>{{ product.TotalAmount | currency }}</strong></td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-flex>

                    <!-- Danh sách Export Receipt TMĐT -->
                    <v-flex lg12 md12 sm12 v-if="receipts.length > 0">
                        <v-subheader class="px-0">Phiếu xuất TMĐT ({{ receipts.length }})</v-subheader>
                        <v-data-table :headers="receiptHeaders" :items="receipts" hide-default-footer disable-pagination fixed-header :height="tableHeight"
                            :show-select="!isHistory" v-model="localSelectedReceipts" item-key="ID"
                            show-expand :expanded.sync="expandedReceipts"
                            class="elevation-1"
                            @item-selected="updateTotalAmount"
                            @toggle-select-all="updateTotalAmount">
                            <template v-slot:item.CreatedDate="{ item }">
                                {{ item.CreatedDate | display_date }}
                            </template>
                            <template v-slot:item.ExportDate="{ item }">
                                {{ item.ExportDate | display_date }}
                            </template>
                            <template v-slot:item.Weight="{ item }">
                                {{ item.Weight | currency('', 1) }}
                            </template>
                            <template v-slot:item.Volume="{ item }">
                                {{ item.Volume | currency('', 2) }}
                            </template>
                            <template v-slot:item.TotalAmount="{ item }">
                                {{ item.TotalAmount | currency }}
                            </template>
                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length" class="pa-0">
                                    <v-simple-table dense class="product-table">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="grey lighten-4">
                                                    <th>Mã vận đơn</th>
                                                    <th class="text-right">Cân nặng</th>
                                                    <th class="text-right">Thể tích</th>
                                                    <th class="text-right">Số kiện</th>
                                                    <th>Ghi chú</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="!item.packages || item.packages.length === 0">
                                                    <td colspan="5" class="text-center grey--text">Không có kiện hàng</td>
                                                </tr>
                                                <tr v-for="(pkg, idx) in item.packages" :key="idx">
                                                    <td>{{ pkg.TrackingCode }}</td>
                                                    <td class="text-right">{{ pkg.Weight | currency('', 1) }}</td>
                                                    <td class="text-right">{{ pkg.Volume | currency('', 2) }}</td>
                                                    <td class="text-right">{{ pkg.NumberOfPack || 1 }}</td>
                                                    <td>{{ pkg.Note }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" outlined @click="closeDialog">Đóng</v-btn>
                <v-btn v-if="!isHistory" color="primary" @click="printPaymentRequest" :disabled="!hasSelection">
                    <v-icon left>mdi-printer</v-icon>In phiếu
                </v-btn>
                <v-btn v-if="!isHistory" color="orange" outlined @click="saveDraftPayment" :disabled="!canSaveDraft" :loading="savingDraft">
                    <v-icon left>mdi-content-save</v-icon>Lưu phiếu
                </v-btn>
                <v-btn v-if="!isHistory" color="success" @click="confirmPayment" :disabled="!canProcessPayment" :loading="loadingDraft">
                    <v-icon left>mdi-credit-card</v-icon>Thanh toán
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import _ from "lodash";
import fileUploadService from "@/services/fileUploadService";
import configs from "@/configs";

export default {
    props: {
        value: Boolean,
        title: {
            type: String,
            default: 'Chi tiết thanh toán'
        },
        customer: {
            type: Object,
            default: () => ({})
        },
        bills: {
            type: Array,
            default: () => []
        },
        receipts: {
            type: Array,
            default: () => []
        },
        selectedBills: {
            type: Array,
            default: () => []
        },
        selectedReceipts: {
            type: Array,
            default: () => []
        },
        isHistory: {
            type: Boolean,
            default: false
        },
        shippingFee: {
            type: Number,
            default: 0
        },
        otherFee: {
            type: Number,
            default: 0
        },
        note: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            localSelectedBills: [],
            localSelectedReceipts: [],
            localShippingFee: 0,
            localOtherFee: 0,
            localNote: '',
            paymentImageFile: null,
            paymentImageUrl: null,
            uploadingFile: false,
            tableHeight: 320,
            expandedBills: [],
            expandedReceipts: [],
            draftPaymentId: null,
            loadingDraft: false,
            savingDraft: false,
        };
    },
    computed: {
        ...mapState({
            product_types: state => state.productType.all.data,
        }),
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        hasSelection() {
            return this.localSelectedBills.length > 0 || this.localSelectedReceipts.length > 0;
        },
        totalAmount() {
            const billTotal = _.sumBy(this.localSelectedBills, 'TotalAmount') || 0;
            const receiptTotal = _.sumBy(this.localSelectedReceipts, 'TotalAmount') || 0;
            return billTotal + receiptTotal;
        },
        finalAmount() {
            return this.totalAmount + this.localShippingFee + this.localOtherFee;
        },
        billHeaders() {
            return [
                { text: 'Mã Bill', value: 'BillCode', sortable: false },
                { text: 'Ngày tạo', value: 'CreatedDate', sortable: false },
                { text: 'Số kiện', value: 'NumberOfPack', align: 'end', sortable: false },
                { text: 'Cân nặng', value: 'Weight', align: 'end', sortable: false },
                { text: 'Thể tích', value: 'Volume', align: 'end', sortable: false },
                { text: 'Tiền hàng', value: 'Amount', align: 'end', sortable: false },
                { text: 'Phí ship', value: 'ShipPrice', align: 'end', sortable: false },
                { text: 'Tổng thanh toán', value: 'TotalAmount', align: 'end', sortable: false }
            ];
        },
        receiptHeaders() {
            const headers = [
                { text: 'Mã PX', value: 'ID', sortable: false },
                { text: 'Ngày tạo', value: 'CreatedDate', sortable: false },
                { text: 'Ngày xuất', value: 'ExportDate', sortable: false },
                { text: 'Cân nặng', value: 'Weight', align: 'end', sortable: false },
                { text: 'Thể tích', value: 'Volume', align: 'end', sortable: false },
                { text: 'Số kiện', value: 'NumberOfPack', align: 'end', sortable: false },
                { text: 'Thành tiền', value: 'TotalAmount', align: 'end', sortable: false },
                { text: 'Ghi chú', value: 'Note', sortable: false },
            ];
            return headers;
        },
        payableRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.StoreBatch;
        },
        canProcessPayment() {
            return this.hasSelection && this.paymentImageUrl && !this.isHistory && this.payableRole;
        },
        canSaveDraft() {
            return this.paymentImageUrl && !this.isHistory;
        },
        paymentQrImage() {
            const config = this.$store.state.configuration && this.$store.state.configuration.selected;
            if (config && config.PaymentQrImage && config.PaymentQrImage.trim() !== '') {
                return config.PaymentQrImage;
            }
            return '/static/tcb-9036543710011-qr.png';
        },
    },
    watch: {
        value(val) {
            if (val) {
                if (!this.$store.state.configuration || !this.$store.state.configuration.selected || !this.$store.state.configuration.selected.ID) {
                    this.$store.dispatch('configuration/getDetail', 1);
                }
                this.localSelectedBills = [...this.bills];
                this.localSelectedReceipts = [...this.receipts];
                this.localShippingFee = this.shippingFee;
                this.localOtherFee = this.otherFee;
                this.localNote = this.note;
                this.paymentImageFile = null;
                this.paymentImageUrl = null;
                this.draftPaymentId = null;
                
                // Load draft payment if exists
                this.loadDraftPayment();
            }
        }
    },
    mounted() {
        if (!this.$store.state.configuration || !this.$store.state.configuration.selected || !this.$store.state.configuration.selected.ID) {
            this.$store.dispatch('configuration/getDetail', 1);
        }
    },
    methods: {
        async loadDraftPayment() {
            if (!this.customer || !this.customer.CustomerID && !this.customer.ID) {
                return;
            }
            
            this.loadingDraft = true;
            try {
                const customerId = this.customer.CustomerID || this.customer.ID;
                const response = await this.$store.dispatch('payment/getDraftPayment', { customer_id: customerId });
                
                if (response && response.data) {
                    const draft = response.data;
                    this.draftPaymentId = draft.ID;
                    this.paymentImageUrl = draft.PaymentImage;
                    this.localShippingFee = draft.ShippingFee || 0;
                    this.localOtherFee = draft.OtherFee || 0;
                    this.localNote = draft.Note || '';
                }
            } catch (error) {
                // No draft found is not an error, just ignore
                console.log('No draft payment found');
            } finally {
                this.loadingDraft = false;
            }
        },
        async saveDraftPayment() {
            if (!this.paymentImageUrl) {
                sendErrorNotice('Vui lòng upload file thanh toán trước');
                return;
            }
            
            this.savingDraft = true;
            try {
                // Upload image if a new file is selected
                let imageUrl = this.paymentImageUrl;
                if (this.paymentImageFile) {
                    const uploadedUrl = await this.uploadPaymentImage();
                    if (!uploadedUrl) {
                        sendErrorNotice('Lỗi upload file thanh toán');
                        return;
                    }
                    imageUrl = uploadedUrl;
                }
                
                const payload = {
                    customer_info: {
                        CustomerID: this.customer.CustomerID || this.customer.ID,
                        Username: this.customer.Username || this.customer.CustomerUsername,
                        FullName: this.customer.FullName || this.customer.CustomerFullName,
                        PhoneNumber: this.customer.PhoneNumber || this.customer.CustomerPhone
                    },
                    shipping_fee: this.localShippingFee,
                    other_fee: this.localOtherFee,
                    note: this.localNote,
                    payment_image: imageUrl
                };
                
                if (this.draftPaymentId) {
                    payload.draft_id = this.draftPaymentId;
                }
                
                const response = await this.$store.dispatch('payment/saveDraftPayment', payload);
                if (response && response.data) {
                    this.draftPaymentId = response.data.ID;
                    sendSuccessNotice('Đã lưu phiếu nháp thành công');
                }
            } catch (error) {
                const errorMsg = (error.data && error.data.reason) || error.message || error;
                sendErrorNotice('Lỗi khi lưu phiếu nháp: ' + errorMsg);
            } finally {
                this.savingDraft = false;
            }
        },
                isImageFile(url) {
                    if (!url) return false;
                    const ext = url.split('.').pop().toLowerCase();
                    return ['jpg', 'jpeg', 'png', 'gif'].includes(ext);
                },
        closeDialog() {
            this.$emit('close');
        },
        updateTotalAmount() {
            this.$emit('update:selectedBills', this.localSelectedBills);
            this.$emit('update:selectedReceipts', this.localSelectedReceipts);
            this.$emit('update:shippingFee', this.localShippingFee);
            this.$emit('update:otherFee', this.localOtherFee);
            this.$emit('update:note', this.localNote);
        },
        handleImageUpload(file) {
            if (!file) {
                this.paymentImageFile = null;
                this.paymentImageUrl = null;
                return;
            }

            // Validate file type and size (max 10MB) similar to bill detail
            const validation = fileUploadService.validateFile(file, ['jpg', 'jpeg', 'png', 'pdf'], 10);
            if (!validation.valid) {
                sendErrorNotice(validation.message);
                this.paymentImageFile = null;
                this.paymentImageUrl = null;
                return;
            }

            // Preview for images
            const previewUrl = fileUploadService.generatePreviewUrl(file);
            if (previewUrl) {
                this.paymentImageUrl = previewUrl;
            } else {
                this.paymentImageUrl = null;
            }
        },
        async uploadPaymentImage() {
            if (!this.paymentImageFile) {
                return null;
            }

            this.uploadingFile = true;
            try {
                const result = await fileUploadService.uploadSingleFile(this.paymentImageFile, 'payment');
                if (result.success) {
                    const fullUrl = `${result.data.url}`;
                    this.paymentImageUrl = fullUrl || result.data.url;
                    return this.paymentImageUrl;
                } else {
                    sendErrorNotice(result.message);
                    return null;
                }
            } catch (error) {
                const msg = (error && error.message) ? error.message : error;
                sendErrorNotice('Lỗi upload file: ' + msg);
                return null;
            } finally {
                this.uploadingFile = false;
            }
        },
        async deletePaymentImage() {
            this.paymentImageFile = null;
            this.paymentImageUrl = null;
            if (this.draftPaymentId) {
                this.$store.dispatch('payment/saveDraftPayment', { draft_id: this.draftPaymentId, payment_image: null });
            }
            sendSuccessNotice('Đã xóa bill thanh toán');
        },
        confirmPayment() {
            if (!this.hasSelection) {
                sendErrorNotice("Vui lòng chọn ít nhất một sản phẩm để thanh toán");
                return;
            }
            const doProcess = async () => {
                const uniqueBillIds = this.localSelectedBills.map(b => b.ID);
                const receiptIds = this.localSelectedReceipts.map(r => r.ID);

                // Upload image if a new file is selected
                let imageUrl = this.paymentImageUrl;
                if (this.paymentImageFile) {
                    const uploadedUrl = await this.uploadPaymentImage();
                    if (!uploadedUrl) {
                        sendErrorNotice('Lỗi upload bill thanh toán');
                        return;
                    }
                    imageUrl = uploadedUrl;
                }

                const paymentPayload = {
                    bill_ids: uniqueBillIds,
                    receipt_ids: receiptIds,
                    customer_info: {
                        CustomerID: this.customer.CustomerID || this.customer.ID,
                        Username: this.customer.Username || this.customer.CustomerUsername,
                        FullName: this.customer.FullName || this.customer.CustomerFullName,
                        PhoneNumber: this.customer.PhoneNumber || this.customer.CustomerPhone
                    },
                    shipping_fee: this.localShippingFee,
                    other_fee: this.localOtherFee,
                    note: this.localNote,
                    payment_image: imageUrl
                };
                
                // If there's a draft, include the draft_id to update it
                if (this.draftPaymentId) {
                    paymentPayload.draft_id = this.draftPaymentId;
                }
                
                this.$store.dispatch('payment/processPayment', paymentPayload).then(response => {
                    sendSuccessNotice("Thanh toán thành công");
                    this.$emit('payment-success');
                }).catch(error => {
                    const errorMsg = (error.data && error.data.reason) || error.message || error;
                    sendErrorNotice("Lỗi khi thanh toán: " + errorMsg);
                });
            };

            doProcess();
        },
        printPaymentRequest() {
            if (!this.hasSelection) {
                sendErrorNotice("Vui lòng chọn ít nhất một sản phẩm để in");
                return;
            }

            const selectedProductsFlat = [];
            this.localSelectedBills.forEach(bill => {
                if (bill.products) {
                    bill.products.forEach(p => {
                        selectedProductsFlat.push({
                            ...p,
                            BillCode: bill.BillCode,
                            ExportDate: bill.ExportDate
                        });
                    });
                }
            });

            let content = `
                <html>
                <head>
                    <title>Phiếu đề nghị thanh toán</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        h2 { text-align: center; }
                        h3 { margin-top: 30px; border-bottom: 2px solid #333; padding-bottom: 5px; }
                        .info-container { display: table; width: 100%; margin-bottom: 20px; }
                        .info { display: table-cell; width: 70%; vertical-align: top; }
                        .info p { margin: 5px 0; }
                        .qr-box { display: table-cell; width: 30%; vertical-align: top; text-align: center; padding-left: 20px; }
                        .qr-box img { max-width: 120px; margin-top: 10px; border: 1px solid #ddd; padding: 5px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                        th, td { border: 1px solid #000; padding: 6px; text-align: left; font-size: 11px; }
                        th { background-color: #f2f2f2; font-weight: bold; }
                        .text-right { text-align: right; }
                        .text-center { text-align: center; }
                        .total { font-weight: bold; background-color: #e0e0e0; }
                        .signature { margin-top: 50px; }
                        .signature-box { display: inline-block; width: 45%; text-align: center; }
                        .page-break { page-break-before: always; }
                    </style>
                </head>
                <body>
                    <h2>PHIẾU ĐỀ NGHỊ THANH TOÁN</h2>
                    
                    <div class="info-container">
                        <div class="info">
                            <p><strong>Khách hàng:</strong> ${this.customer.FullName || this.customer.CustomerFullName} (${this.customer.Username || this.customer.CustomerUsername})</p>
                            <p><strong>Số điện thoại:</strong> ${this.customer.PhoneNumber || this.customer.CustomerPhone}</p>
                            <p><strong>Ngày thanh toán:</strong> ${new Date().toLocaleDateString('vi-VN')}</p>
                        </div>
                        <div class="qr-box">
                            <img src="${this.paymentQrImage}" alt="QR thanh toán">
                        </div>
                    </div>
            `;

            if (selectedProductsFlat.length > 0) {
                content += `<h3>Danh sách hàng (${selectedProductsFlat.length} sản phẩm)</h3>`;
                content += `
                    <table>
                        <thead>
                            <tr>
                                <th width="5%">STT</th>
                                <th width="10%">Ngày xuất</th>
                                <th width="13%">Tên hàng</th>
                                <th width="10%">Mã hàng</th>
                                <th width="7%" class="text-right">Kg/M³</th>
                                <th width="6%" class="text-center">ĐVT</th>
                                <th width="9%" class="text-right">Đơn giá</th>
                                <th width="10%" class="text-right">Thành tiền</th>
                                <th width="8%" class="text-right">Ship nội địa</th>
                                <th width="8%" class="text-right">Xe lôi</th>
                                <th width="8%" class="text-right">Phí hạ hàng</th>
                                <th width="8%" class="text-right">Phí đóng gỗ</th>
                                <th width="8%" class="text-right">Tổng</th>
                            </tr>
                        </thead>
                        <tbody>
                `;
                
                selectedProductsFlat.forEach((product, index) => {
                    const weightVolume = product.PriceTypeAuto == 1 ? product.Weight : product.Volume;
                    const unit = product.PriceTypeAuto == 1 ? 'Kg' : 'M³';
                    const unitPrice = product.PriceTypeAuto == 1 ? product.WeightPrice : product.VolumePrice;
                    const totalPayment = product.TotalAmount || 0;
                    
                    content += `
                        <tr>
                            <td class="text-center">${index + 1}</td>
                            <td class="text-center">${product.ExportDate ? this.$options.filters.display_date(product.ExportDate) : '-'}</td>
                            <td>${product.ProductName || '-'}</td>
                            <td>${product.ProductCode || '-'}</td>
                            <td class="text-right">${this.$options.filters.currency(weightVolume, '', product.PriceTypeAuto == 1 ? 1 : 2)}</td>
                            <td class="text-center">${unit}</td>
                            <td class="text-right">${this.$options.filters.currency(unitPrice)}</td>
                            <td class="text-right">${this.$options.filters.currency(product.TotalFeeWeight)}</td>
                            <td class="text-right">${this.$options.filters.currency(product.TransactionDeposit)}</td>
                            <td class="text-right">${this.$options.filters.currency(product.PedicabDeposit)}</td>
                            <td class="text-right">${this.$options.filters.currency(product.LoadDeposit)}</td>
                            <td class="text-right">${this.$options.filters.currency(product.ReinforceDeposit)}</td>
                            <td class="text-right"><strong>${this.$options.filters.currency(totalPayment)}</strong></td>
                        </tr>
                    `;
                });

                const productTotal = _.sumBy(selectedProductsFlat, 'TotalAmount');
                content += `
                        <tr class="total">
                            <td colspan="12" class="text-right"><strong>TỔNG CỘNG:</strong></td>
                            <td class="text-right"><strong>${this.$options.filters.currency(productTotal)}</strong></td>
                        </tr>
                        </tbody>
                    </table>
                `;
            }

            if (this.localSelectedReceipts.length > 0) {
                if (this.localSelectedBills.length > 0) {
                    content += `<div class="page-break"></div>`;
                }
                
                content += `<h3>Phiếu xuất TMĐT (${this.localSelectedReceipts.length})</h3>`;
                
                this.localSelectedReceipts.forEach((receipt, receiptIndex) => {
                    if (receiptIndex > 0) {
                        content += `<div class="page-break"></div>`;
                    }
                    
                    content += `
                        <h4>Phiếu xuất #${receipt.ID} - Ngày xuất: ${this.$options.filters.display_date(receipt.ExportDate)}</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th width="10%">STT</th>
                                    <th width="30%">Mã vận đơn</th>
                                    <th width="15%" class="text-right">Số kiện</th>
                                    <th width="20%" class="text-right">Cân nặng (kg)</th>
                                    <th width="25%" class="text-right">Thể tích (m³)</th>
                                </tr>
                            </thead>
                            <tbody>
                    `;
                    
                    if (receipt.packages && receipt.packages.length > 0) {
                        receipt.packages.forEach((pkg, index) => {
                            content += `
                                <tr>
                                    <td class="text-center">${index + 1}</td>
                                    <td>${pkg.TrackingCode}</td>
                                    <td class="text-right">${pkg.NumberOfPack || 1}</td>
                                    <td class="text-right">${this.$options.filters.currency(pkg.Weight, '', 1)}</td>
                                    <td class="text-right">${this.$options.filters.currency(pkg.Volume, '', 2)}</td>
                                </tr>
                            `;
                        });
                    }
                    
                    content += `
                                <tr class="total">
                                    <td colspan="2"><strong>Tổng phiếu #${receipt.ID}</strong></td>
                                    <td class="text-right"><strong>${receipt.NumberOfPack || 0}</strong></td>
                                    <td class="text-right"><strong>${this.$options.filters.currency(receipt.Weight, '', 1)}</strong></td>
                                    <td class="text-right"><strong>${this.$options.filters.currency(receipt.Volume, '', 2)}</strong></td>
                                </tr>
                                <tr class="total">
                                    <td colspan="4" class="text-right"><strong>Thành tiền:</strong></td>
                                    <td class="text-right"><strong>${this.$options.filters.currency(receipt.TotalAmount)}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    `;
                });

                const receiptTotal = _.sumBy(this.localSelectedReceipts, 'TotalAmount');
                content += `
                    <table style="margin-top: 20px;">
                        <tr class="total">
                            <td colspan="4" class="text-right"><strong>TỔNG CỘNG TMĐT:</strong></td>
                            <td class="text-right"><strong>${this.$options.filters.currency(receiptTotal)}</strong></td>
                        </tr>
                    </table>
                `;
            }

            // Tính tổng với phí
            const grandTotal = this.totalAmount + this.localShippingFee + this.localOtherFee;

            content += `
                    <table style="margin-top: 20px;">
                        <tr>
                            <td colspan="4" class="text-right"><strong>Tổng tiền hàng:</strong></td>
                            <td class="text-right"><strong>${this.$options.filters.currency(this.totalAmount)}</strong></td>
                        </tr>
                        <tr>
                            <td colspan="4" class="text-right"><strong>Phí ship:</strong></td>
                            <td class="text-right">${this.$options.filters.currency(this.localShippingFee)}</td>
                        </tr>
                        <tr>
                            <td colspan="4" class="text-right"><strong>Phí khác:</strong></td>
                            <td class="text-right">${this.$options.filters.currency(this.localOtherFee)}</td>
                        </tr>
                        <tr class="total">
                            <td colspan="4" class="text-right"><strong>TỔNG CỘNG THANH TOÁN:</strong></td>
                            <td class="text-right"><strong>${this.$options.filters.currency(grandTotal)}</strong></td>
                        </tr>
                    </table>
            `;
            
            if (this.localNote) {
                content += `
                    <div style="margin-top: 20px;">
                        <strong>Ghi chú:</strong> ${this.localNote}
                    </div>
                `;
            }

            content += `
                    <div class="signature">
                        <div class="signature-box">
                            <p><strong>Người đề nghị</strong></p>
                            <br><br><br>
                            <p>_____________________</p>
                        </div>
                        <div class="signature-box" style="float: right;">
                            <p><strong>Kế toán trưởng</strong></p>
                            <br><br><br>
                            <p>_____________________</p>
                        </div>
                    </div>
                </body>
                </html>
            `;

            const printWindow = window.open('', '', 'height=600,width=800');
            printWindow.document.write(content);
            printWindow.document.close();
            
            // Đợi ảnh QR code load xong trước khi in
            const qrImage = printWindow.document.querySelector('img[alt="QR thanh toán"]');
            if (qrImage) {
                if (qrImage.complete) {
                    // Ảnh đã load sẵn
                    printWindow.focus();
                    printWindow.print();
                } else {
                    // Đợi ảnh load xong
                    qrImage.onload = function() {
                        printWindow.focus();
                        printWindow.print();
                    };
                    // Xử lý trường hợp ảnh lỗi
                    qrImage.onerror = function() {
                        console.warn('QR image failed to load');
                        printWindow.focus();
                        printWindow.print();
                    };
                }
            } else {
                // Không có ảnh QR, in ngay
                printWindow.focus();
                printWindow.print();
            }
        }
    }
};
</script>

<style scoped>
.mb-2 {
    margin-bottom: 8px;
}

.mb-3 {
    margin-bottom: 16px;
}

.mb-4 {
    margin-bottom: 24px;
}

.mt-2 {
    margin-top: 8px;
}

/* Compact header area styles */
.info-grid {
    margin-bottom: 8px;
}
.info-item .label,
.field-item .label {
    font-size: 12px;
    color: #757575;
}
.info-item .value {
    font-weight: 600;
}

/* Product table styles */
.product-table {
    background-color: #fafafa;
}
.product-table th {
    font-size: 12px;
    font-weight: 600;
}
.product-table td {
    font-size: 12px;
    padding: 4px 8px !important;
}
</style>
